import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  emp_firstName: "",
  emp_Designation: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetState: () => initialState,
    addUserState: (state, action) => {
      const { emp_firstName, emp_Designation } = action.payload;
      if (emp_firstName && emp_Designation) {
        state.emp_firstName = emp_firstName;
        state.emp_Designation = emp_Designation;
      }
    },
  },
});

export const { resetState, addUserState } = userSlice.actions;
export default userSlice.reducer;
